import { useState, useEffect } from "react";

export const useHappyNewYear = () => {
  const currentYear = new Date().getFullYear();
  const currentDate = new Date();
  const isWithinNewYearPeriod =
    currentDate.getMonth() === 0 && currentDate.getDate() <= 15;

  const [showHappyNewYearModal, setShowHappyNewYearModal] = useState(false);

  useEffect(() => {
    if (isWithinNewYearPeriod) {
      const seenYear = localStorage.getItem("hasSeenHappyNewYearModalYear");

      if (seenYear !== String(currentYear)) {
        setShowHappyNewYearModal(true);
        localStorage.setItem(
          "hasSeenHappyNewYearModalYear",
          String(currentYear)
        );
      }
    }
  }, [isWithinNewYearPeriod, currentYear]);

  return { showHappyNewYearModal, setShowHappyNewYearModal, currentYear };
};

export default useHappyNewYear;
